import { ReactNode } from "react";
import LevelBadge from "../../global/LevelBadge";
import "../../assets/css/component/board/BoardDetail.css";

export type BoardPost = {
    id: number;
    title: string;
    content: string;
    authorId: number;
    authorNickname: string;
    authorLevel: number;
    viewCount: number;
    createdAt: string;
};

export function formatBoardDate(value: string): string {
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return "-";
    const pad = (n: number) => String(n).padStart(2, "0");
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
}

export default function BoardDetail({ post, actions }: { post: BoardPost; actions: ReactNode }) {
    return (
        <article className="BoardDetail">
            <h1 className="PostTitle">{post.title}</h1>
            <div className="PostActions">{actions}</div>
            <div className="PostMeta">
                <span className="BoardAuthor"><LevelBadge level={post.authorLevel} />{post.authorNickname}</span>
                <time dateTime={post.createdAt}>{formatBoardDate(post.createdAt)}</time>
                <span>조회 {post.viewCount.toLocaleString()}</span>
            </div>
            <div className="PostContentCard">
                <div className="PostContent" dangerouslySetInnerHTML={{ __html: post.content }} />
            </div>
        </article>
    );
}
